import { css } from "../../styled-system/css";

export const styles = {
  breadcrumbWrapper: () =>
    css({
      paddingBottom: "baseUnit.mobile2",
      desktop: {
        paddingBottom: "baseUnit.mobile3",
      },
    }),
  contactCardWrapper: () =>
    css({
      paddingBottom: "baseUnit.mobile8",
    }),
  progressWrapper: () =>
    css({
      marginTop: "baseUnit.mobile1",
    }),
  loaderWrapper: () =>
    css({
      position: "relative",
      height: "220px",
    }),
  recaptchaWrapper: () =>
    css({
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      left: "0",
      right: "0",
      zIndex: "floatingHigh",
    }),
};
